import request from '@/utils/request'

// 字典「寫入」的錯誤由呼叫方（adminEditOptions.vue）自己處理：
// 後端會回兩類 422（Laravel 欄位校驗 / 業務 result:"fail"），要彈的是中文自訂對話框，
// 所以帶 skipErrorMessage 關掉攔截器的自動提示，避免「英文訊息 + 中文框」雙份彈。
// create manage-properties
export function creatManageProperties (data) {
  return request({
    url: '/api/manage-properties',
    method: 'POST',
    data,
    skipErrorMessage: true
  })
}

// get manage-properties
export function getManageProperties (type) {
  return request({
    url: `/api/manage-properties?type=${type}`,
    method: 'GET'
  })
}

// delect manage-properties
export function delectManageProperties (id) {
  return request({
    url: `/api/manage-properties/${id}`,
    method: 'DEL'
  })
}

// eidt manage-properties
export function editManageProperties (id, data) {
  return request({
    url: `/api/manage-properties/${id}`,
    method: 'PUT',
    data,
    skipErrorMessage: true
  })
}

// change sort
export function sortManageProperties (id, data) {
  return request({
    url: `/api/manage-properties/${id}/change-sort`,
    method: 'PUT',
    data
  })
}
